var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUpPlaceholderImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6921 29.3396V4.152C32.6921 2.17298 31.0729 0.553772 29.0938 0.553772H3.90621C1.92719 0.553772 0.307983 2.17298 0.307983 4.152V29.3396C0.307983 31.3186 1.92719 32.9379 3.90621 32.9379H29.0938C31.0729 32.9379 32.6921 31.3186 32.6921 29.3396ZM10.2031 19.4445L14.7009 24.8598L20.9978 16.7458L29.0938 27.5405H3.90621L10.2031 19.4445Z",
    fill: "#9FA5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpPlaceholderImg);
export default __webpack_public_path__ + "static/media/sign_up_placeholder_img.97a101d293081dcffed7ea98a544df5c.svg";
export { ForwardRef as ReactComponent };